import { render, staticRenderFns } from "./TicketDetailChangeLineClass.vue?vue&type=template&id=038dc210&scoped=true"
import script from "./TicketDetailChangeLineClass.vue?vue&type=script&lang=js"
export * from "./TicketDetailChangeLineClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038dc210",
  null
  
)

export default component.exports